import { MDBBtn, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { creatCallBlocking, editCallBlocking } from '../../../apiclients/streamsapi_bridge';
import { formattedNumber } from '../phonenumbers/AddRemoveNumbers';

function SwitchCallBlockingNum(props) {
    const { t, i18n } = useTranslation();
    const [isloading, setIsloading] = useState(false)

    async function switchBlocking(e) {
        let moObj = props.updateObj;
        moObj.delete_confirm = "true";
        if (props.createFlag) {
            console.log(" create white and black  " + JSON.stringify(moObj))
            let saverep = await creatCallBlocking(moObj);
            let saverepeMsg = await saverep.json();
            console.log("reposnse of add :::::::" + JSON.stringify(saverepeMsg));

            if (saverepeMsg.status && saverepeMsg.status == "success") {
                const rowid = saverepeMsg.unique_id ?? "";
                const createdDate = saverepeMsg.created_date ?? "";
                const modifiedObj = {
                    unique_id: rowid,
                    created_date: createdDate,
                    comment: props.formObj.comment,
                    ph_number: formattedNumber(props.formObj.phnum),
                }
                props.setSuccessMessage(saverepeMsg.message);
                props.modifiedObj(modifiedObj);
                props.modifyFlag(true);
                props.onClose();
                props.closeMain();

            } else {
                props.displaySeverError(saverepeMsg);
                props.onClose();
            }

        } else {
            let saverep = await editCallBlocking(moObj);
            let saverepeMsg = await saverep.json();
            console.log("Reponse for update  call blocking ::::: " + JSON.stringify(saverepeMsg));

            if (saverepeMsg.status && saverepeMsg.status === "success") {
                const createdDate = saverepeMsg.created_date ?? "";
                props.setSuccessMessage(saverepeMsg.message);
                const modifiedObj = {
                    unique_id: moObj.unique_id,
                    created_date: createdDate,
                    comment: props.formObj.comment,
                    ph_number: formattedNumber(props.formObj.phnum),
                    isEdited: true,
                }
                props.modifiedObj(modifiedObj);
                props.modifyFlag(true);
                props.onClose();
                props.closeMain();
            } else {
                props.displaySeverError(saverepeMsg);
                props.onClose();
            }
        }
    }

    return (
        <>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            <div>
                <span className="phrecording">{props.errorMessage}</span>
            </div>
            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => switchBlocking(e)}>{t("ok")}</MDBBtn>
            </MDBModalFooter>
        </>
    );
};

export default SwitchCallBlockingNum;
